import React, { useEffect } from "react";
import LoginNavbar from "./LoginNavbar";
import ResetPage from "./ResetPage";
import { useHistory } from "react-router-dom";
import {useLocation} from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
  }  

export default function Reset() {
  const query = useQuery()
  const history = useHistory();
  const token = query.get("token")


  useEffect(() => {
    const itemStr = localStorage.getItem("userData");
    if (itemStr) {
      history.push("/");
    }
    document.title = "VisaPro | Reset Password";

  }, []);
  
  return (
    <div>
      <LoginNavbar />
      <ResetPage token={token} />
    </div>
  );
}
